<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex align-items-center p-3 my-3 text-dark-50 bg-lightblue rounded shadow-sm">
          <div class="lh-100">
            <h6 class="border-bottom border-gray pb-2 mb-0 lh-100">User-wise</h6>
          </div>
          <div class="form-group ml-auto">
            <date-range-picker
                style="width: 100%;"
                ref="picker"
                class="form-control"
                :opens="dateRangeConf.opens"
                :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
                :minDate="dateRangeConf.minDate" :maxDate="dateRangeConf.maxDate"
                :singleDatePicker="dateRangeConf.singleDatePicker"
                :timePicker="dateRangeConf.timePicker"
                :timePicker24Hour="dateRangeConf.timePicker24Hour"
                :showWeekNumbers="dateRangeConf.showWeekNumbers"
                :showDropdowns="dateRangeConf.showDropdowns"
                :autoApply="dateRangeConf.autoApply"
                v-model="expiryDate"
                @update="getOnLoadMessageLogs"
            > <!-- @change="getOnLoadMessageLogs" -->
            </date-range-picker>
          </div>
          <div class="form-group ml-3 mb-0 d-flex align-items-center">
            <input id="cumulate-user-wise" v-model="cumulate" type="checkbox" class="mr-2">
            <label for="cumulate-user-wise" class="mb-0">Cumulate</label>
          </div>
          <!--          <div class="form-group ml-auto">-->
          <!--            &lt;!&ndash;            <label for="integrated_number" class="col-form-label">Integrated Number <span&ndash;&gt;-->
          <!--            &lt;!&ndash;                class="text-danger">*</span></label>&ndash;&gt;-->
          <!--            <select class="form-control" id="integrated_number" v-model="integrated_number" required> &lt;!&ndash; @change="getOnLoadMessageLogs" &ndash;&gt;-->
          <!--              <option v-for="(option, key) in phones" :value="option.phonenumberId" :key="key">{{ option.name }}-->
          <!--                (+91 {{ option.phonenumber }})-->
          <!--              </option>-->
          <!--            </select>-->
          <!--          </div>-->
          <div class="form-group ml-auto">
            <button v-if="displayTables.length > 0" @click="downloadExcel" class="btn btn-success">Download Excel</button>
          </div>
        </div>
        <!-- Modal Structure -->
        <div class="modal fade" id="myModal" tabindex="-1" aria-labelledby="myModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="myModalLabel">{{ modal_title }}</h5>
                <button type="button" class="btn-close" @click="closeModal" aria-label="Close">X</button>
              </div>
              <div class="modal-body">
                <p class="blink_var" style="
    border: 1px solid;
    border-radius: 10px;
    text-align: center;
    padding: 5px;
    background-color: aliceblue;
" v-html="this.preview"></p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" @click="closeModal">Close</button>
                <!--                <button type="button" class="btn btn-primary">Save changes</button>-->
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive table-scroll">
          <table class="table">
            <thead class="text-bold">
            <tr>
              <th scope="col">SENT BY</th>
              <th scope="col">FROM</th>
              <th scope="col">PRICING</th>
              <th scope="col">TEMPLATE</th>
              <th scope="col">SUBMITTED</th>
              <th scope="col">SENT</th>
              <th scope="col">DELIVERED</th>
              <th scope="col">READ</th>
              <th scope="col">FAILED</th>
              <th scope="col">BLOCKED</th>
              <th scope="col">MARKETING FAILED</th>
              <th scope="col">PENDING</th>
              <th scope="col">FILE</th>
              <th scope="col">DATETIME</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, index) in displayTables" :key="row.isCumulative ? `cumulative-${row.username}` : (row.id || index)">
              <td>{{ row.username }}</td>
              <td>{{ row.from }}</td>
              <td>{{ ((Number(row.sent) || 0) * 0.115).toFixed(3) }}</td>
              <td :style="row.isCumulative ? '' : 'background-color: mistyrose;cursor: alias;'" @click="!row.isCumulative && this.getTemplateView(row)">{{
                  row.template
                }}
              </td>
              <td>{{ row.total }}</td>
              <td>{{ row.sent }}<span v-if="row.sent > 0 && !row.isCumulative" style="cursor: pointer;"
                                      @click="this.getFailedList(row, 'sent')"> &nbsp;⬇️</span></td>
              <td>{{ row.delivered }}<span v-if="row.delivered > 0 && !row.isCumulative" style="cursor: pointer;"
                                           @click="this.getFailedList(row, 'delivered')"> &nbsp;⬇️</span></td>
              <td>{{ row.read }}<span v-if="row.read > 0 && !row.isCumulative" style="cursor: pointer;"
                                      @click="this.getFailedList(row, 'read')"> &nbsp;⬇️</span></td>
              <td>{{ row.failed }}<span v-if="row.failed > 0 && !row.isCumulative" style="cursor: pointer;"
                                        @click="this.getFailedList(row, 'failed')"> &nbsp;⬇️</span></td>
              <td>{{ row.blocked }}<span v-if="row.blocked > 0 && !row.isCumulative" style="cursor: pointer;"
                                         @click="this.getFailedList(row, 'blocked')"> &nbsp;⬇️</span></td>
              <td>{{ row.marketing_failed }}<span v-if="row.marketing_failed > 0 && !row.isCumulative" style="cursor: pointer;"
                                         @click="this.getFailedList(row, 'marketing_failed')"> &nbsp;⬇️</span></td>
              <td v-if="row.pending < 1">{{ row.pending }}</td>
              <td v-else style="background-color: red;">{{ row.pending }}</td>
              <td>
                <a v-if="!row.isCumulative"
                    :href="`https://meta.nithra.mobi/inBound/rajas/download/${row.fileName}`"
                    target="_blank"
                    download
                >
                  {{ row.fileName }}
                </a>
                <span v-else>-</span>
              </td>
              <td>{{ row.createdAt ? moment(row.createdAt).format('DD-MM-YYYY hh:mm:ss a') : '-' }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import DateRangePicker from 'daterange-picker-vue3'
//you need to import the CSS manually
import 'daterange-picker-vue3/dist/daterange-picker-vue3.css'
import * as XLSX from "xlsx";

export default {
  components: {
    DateRangePicker
  },
  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())

    // 15th two months prior
    // const minDate = new Date(today)
    // minDate.setMonth(minDate.getMonth() - 2)
    // minDate.setDate(15)

    // 15th in two months
    const maxDate = new Date(today)
    const nextFollowDate = new Date()
    const yesterdayDate = new Date()
    const sevenDate = new Date()
    // maxDate.setMonth(maxDate.getMonth() + 2)
    // maxDate.setDate(now.getDate() + 15)
    nextFollowDate.setDate(now.getDate() + 3)
    yesterdayDate.setDate(now.getDate() - 1)
    sevenDate.setDate(now.getDate() - 7)
    return {
      dateRangeConf: {
        opens: 'center',
        minDate: 'center',
        maxDate: maxDate,
        singleDatePicker: false,
        timePicker: false,
        timePicker24Hour: false,
        showWeekNumbers: false,
        showDropdowns: false,
        autoApply: false,
      },
      expiryDate: {
        'startDate': maxDate,
        'endDate': maxDate
      },
      form: {
        template: 'hellow_world',
        campaign: 'campaign',
        referrel: 'referrel',
        source: 'source',
        fileUpload: null,
      },
      tables: [],
      cumulate: false,
      phones: [],
      waId: "",
      integrated_number: "103758689422024",
      show: true,
      preview: "",
      isOpen: false,
      modal_title: ""
    }
  },
  async created() {
    this.waId = this.$route.params.waId
    var getWaId = await this.getNumberIntegrationList();
    this.phones = getWaId.data.message;
    var getTemp = await this.getMessageAnalytics();
    this.tables = getTemp.data;
  },
  computed: {
    displayTables() {
      if (!this.cumulate) return this.tables;

      const numericFields = [
        'total', 'sent', 'delivered', 'read', 'failed', 'blocked',
        'marketing_failed', 'pending'
      ];
      const users = new Map();

      this.tables.forEach((row) => {
        const username = row.username || 'Unknown';
        if (!users.has(username)) {
          users.set(username, {
            username,
            fromValues: new Set(),
            template: 'All',
            fileName: '-',
            createdAt: null,
            isCumulative: true,
            total: 0,
            sent: 0,
            delivered: 0,
            read: 0,
            failed: 0,
            blocked: 0,
            marketing_failed: 0,
            pending: 0
          });
        }

        const cumulativeRow = users.get(username);
        if (row.from) cumulativeRow.fromValues.add(row.from);
        numericFields.forEach((field) => {
          cumulativeRow[field] += Number(row[field]) || 0;
        });
      });

      return Array.from(users.values()).map((row) => ({
        ...row,
        from: Array.from(row.fromValues).join(', ') || '-'
      }));
    }
  },
  methods: {
    downloadExcel() {
      const data = this.displayTables.map((row) => ({
        sent_by: row.username,
        from: row.from,
        pricing: ((Number(row.sent) || 0) * 0.115).toFixed(3),
        template: row.template,
        submitted: row.total,
        sent: row.sent,
        delivered: row.delivered,
        read: row.read,
        failed: row.failed,
        blocked: row.blocked,
        marketing_failed: row.marketing_failed,
        pending: row.pending,
        file: row.fileName,
        datetime: row.createdAt ? moment(row.createdAt).format('DD-MM-YYYY hh:mm:ss a') : '-'
      }));

      const filename = "USER_WISE_" + moment(new Date()).format('YYYYMMDDHHMMSS') + '.xlsx';
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, filename);
    },
    async getFailedList(data, status = "failed") {
      const getCOnfirm = confirm(`Do you need ${status} numbers list?`);
      if (getCOnfirm) {
        const templateURL = '/whatsApp/get_failed_message';
        const getPrev = await this.axiosRequest(templateURL, {
          from: data.from,
          template: data.template,
          status: status,
          random: data.random
        });
        if (getPrev.data.length > 0) {
          // var filename = "FAILED_" + data.from + "_" + data.template + "_" + moment(new Date()).format('YYYYMMDDHHMMSS') + '.xlsx';
          var filename = status.toUpperCase() + "_" + data.from + "_" + data.template + "_" + getPrev.data.length + "_" + moment(new Date()).format('YYYYMMDDHHMMSS') + '.xlsx';
          var ws = XLSX.utils.json_to_sheet(getPrev.data);
          var wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
          XLSX.writeFile(wb, filename);
        } else {
          alert(`no ${status} numbers!`)
        }
      }
    },
    async getTemplateView(data) {
      this.preview = ""
      this.modal_title = data.from + " - " + data.template
      const templateURL = '/whatsApp/get_template_view';
      const getPrev = await this.axiosRequest(templateURL, {
        from: data.from,
        template: data.template,
        random: data.random
      });
      if (getPrev.data.status && getPrev.data.data.data.length > 0) {
        console.log("yes")
        var strReplace = "";
        var obj = {};
        var tempPreview = []
        getPrev.data.data.data[0].components.forEach((value1) => {
          if (Object.prototype.hasOwnProperty.call(value1, "example")) {
            if (Object.prototype.hasOwnProperty.call(value1.example, "header_handle") && (value1.format).toLowerCase() == 'image') {
              obj['HEADER_IMAGE'] = value1.example.header_handle;
              strReplace = value1.example.header_handle;
              tempPreview.push("<span class='header header_image'>" + "<img src='" + strReplace + "' width='335' height='300'></span>")
            } else if (Object.prototype.hasOwnProperty.call(value1.example, "header_handle") && (value1.format).toLowerCase() == 'video') {
              obj['HEADER_VIDEO'] = value1.example.header_handle;
              strReplace = value1.example.header_handle;
              tempPreview.push("<span class='header header_video'>" + "<iframe src='" + strReplace + "' width='335' height='300'></iframe></span>")
            } else if (Object.prototype.hasOwnProperty.call(value1.example, "header_text")) {
              obj['HEADER_TEXT'] = value1.example.header_text;
              if (value1.text.includes("<i>{{"))
                strReplace = value1.text
              else
                strReplace = value1.text.replaceAll("{{", "<i class='class_i'>{{").replaceAll("}}", "}}</i>");
              tempPreview.push("<span class='header header_text font-weight-bold'>" + strReplace + "</span>")
            } else if (Object.prototype.hasOwnProperty.call(value1.example, "body_text")) {
              obj['BODY_TEXT'] = value1.example.body_text[0];
              if (value1.text.includes("<i>{{"))
                strReplace = value1.text
              else
                strReplace = value1.text.replaceAll("{{", "<i class='class_i'>{{").replaceAll("}}", "}}</i>");
              tempPreview.push("<span class='body body_text font-weight-bold'>" + strReplace + "</span>")
            } else if (Object.prototype.hasOwnProperty.call(value1.example, "footer_text")) {
              obj['FOOTER_TEXT'] = value1.example.footer_text;
              if (value1.text.includes("<i>{{"))
                strReplace = value1.text
              else
                strReplace = value1.text.replaceAll("{{", "<i class='class_i'>{{").replaceAll("}}", "}}</i>");
              tempPreview.push("<span class='footer footer_text font-weight-bold'>" + strReplace + "</span>")
            }
          } else {
            if (value1.type == "BUTTONS") {
              var strReplaceBtn = "";
              var objUrl = [];
              value1.buttons.forEach((valueBtn) => {
                if (Object.prototype.hasOwnProperty.call(valueBtn, "example") && valueBtn.url.includes('{{')) {
                  if (valueBtn.type == 'URL')
                      // obj['BUTTON_URL'] = valueBtn.example;
                    objUrl.push(valueBtn.example);
                  else
                    obj['BUTTON_PAYLOAD'] = valueBtn.example;
                  strReplaceBtn += "<center><span class='buttons font-weight-bold text-decoration-underline text-info text-justify'>" + valueBtn.text + "<br> [URL : " + valueBtn.url.replaceAll("{{", "<i class='class_i'>{{").replaceAll("}}", "}}</i>") + "]</span></center>";
                } else {
                  strReplaceBtn += "<center><span class='buttons font-weight-bold text-decoration-underline text-info text-justify'>" + valueBtn.text + "</span></center>";
                }
              });
              obj['BUTTON_URL'] = objUrl; // extra added
              strReplace = strReplaceBtn;
            } else
              strReplace = "<span class='font-weight-bold'>" + value1.text + "</span>";
            tempPreview.push(strReplace);
          }
          // this.templates[this.form.template].components[index1].text = strReplace;
        })
        this.preview = tempPreview.join('<br><br>');
        setTimeout(() => {
          var previewData = getPrev.data.previewData
          console.log(previewData)
          previewData.forEach(component => {
            component.values.forEach((item, index) => {
              if (item.type === "text") {
                let selector = `span.${component.type}_${item.type} i:nth-child(${index + 1})`;
                let el = document.querySelector(selector);
                if (el) {
                  el.innerHTML = item.value;
                  el.style.color = this.getRandomRed();
                }
              } else if (item.type === "image") {
                let selector = `span.${component.type}_${item.type} img:nth-child(${index + 1})`;
                let el = document.querySelector(selector);
                if (el) {
                  el.src = item.value;
                  // el.style.color = this.getRandomRed();
                }
              } if (item.type === "text" && component.type === "button") {
                let selector = `span.${component.type}s i:nth-of-type(${index + 1})`;
                let el = document.querySelector(selector);
                if (el) {
                  el.innerHTML = item.value;
                  el.style.color = this.getRandomRed();
                }
              }
            });
          });
        }, 500)
      } else {
        console.log("no")
        this.preview = "<span>No template found!., Contact your admin</span><br><br>";
      }
      this.isOpen = true
      const modalElement = document.getElementById('myModal');
      modalElement.classList.add('show');
      modalElement.style.display = 'block'; // Show the modal
      document.body.classList.add('modal-open'); // Prevent background scrolling
      const backdrop = document.createElement('div');
      backdrop.className = 'modal-backdrop fade show';
      document.body.appendChild(backdrop); // Add backdrop
    },
    getRandomRed() {
      let r = 150 + Math.floor(Math.random() * 106); // 150–255 (strong red)
      let g = Math.floor(Math.random() * 80);        // low green
      let b = Math.floor(Math.random() * 80);        // low blue
      return `rgb(${r}, ${g}, ${b})`;
    },
    closeModal() {
      const modalElement = document.getElementById('myModal');
      modalElement.classList.remove('show');
      modalElement.style.display = 'none'; // Hide the modal
      document.body.classList.remove('modal-open'); // Allow background scrolling
      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.remove(); // Remove backdrop
      }
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format('DD-MM-YYYY hh:mm:ss a')
      }
    },
    async getMessageAnalytics() {
      // const templateURL = 'https://graph.facebook.com/v16.0/100312339706932/message_templates?limit=3&access_token=EAAUJ4rpATrABAFJfj9AwJGKRzBX4l3VSNmfLZAlCcVChd8qGX8P6yv3djKZC8Kr9NEKhCagzqIbf8vTiuYt2xBPGjUr9prMuhOgYnvz2PDfcX5ioweo4RFwKOj884xG9beG0XmDPH1n1rmYd2zQJGfoHQQehlUj0gHxZCs1oNSZBEFQUos3qtqgOISZAthbLOC7PP1FRIawQmZC2ZCG3lzM7Xg7ZC41BTIsZD';
      const templateURL = '/whatsApp/message_user_wise';
      return await this.axiosRequest(templateURL, {
        expiryDate: {
          startDate: new Date(moment(this.expiryDate.startDate).format('YYYY-MM-DD 00:00:00')).toISOString(),
          endDate: new Date(moment(this.expiryDate.endDate).format('YYYY-MM-DD 23:59:59')).toISOString()
        },
        integrated_number: this.integrated_number,
        waId: this.integrated_number
      });
    },
    async getNumberIntegrationList() {
      // const templateURL = 'https://graph.facebook.com/v16.0/100312339706932/message_templates?limit=3&access_token=EAAUJ4rpATrABAFJfj9AwJGKRzBX4l3VSNmfLZAlCcVChd8qGX8P6yv3djKZC8Kr9NEKhCagzqIbf8vTiuYt2xBPGjUr9prMuhOgYnvz2PDfcX5ioweo4RFwKOj884xG9beG0XmDPH1n1rmYd2zQJGfoHQQehlUj0gHxZCs1oNSZBEFQUos3qtqgOISZAthbLOC7PP1FRIawQmZC2ZCG3lzM7Xg7ZC41BTIsZD';
      const templateURL = '/whatsApp/number_integration_list';
      return await this.axiosRequest(templateURL, {
        waId: this.waId
      });
    },
    async getOnLoadMessageLogs() {
      var getTemp = await this.getMessageAnalytics();
      this.tables = getTemp.data;
    }
  }
}
</script>
<style>
.table-scroll {
  max-height: 70vh;
  overflow: auto;
}

.table-scroll table {
  border-collapse: separate;
  border-spacing: 0;
}

.table-scroll thead th {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #ffffff;
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.15);
}
@media (min-width: 1024px) {
  .about {
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
}

.bg-lightblue {
  background-color: lightblue;
}

/*td {*/
/*  white-space: normal !important;*/
/*  word-wrap: break-word;*/
/*}*/
/*table {*/
/*  table-layout: fixed;*/
/*}*/
</style>
